<script lang="ts">
  import {onDestroy, onMount} from 'svelte';
  import {getInstance} from '../../../../services/animation';
  import editorInstance from '../../../../lib/editor/editor';
  import editorStore from '../../../../lib/editor/editor.store';
  import FontEditor from '../FontEditor/FontEditor.svelte';
  import {writable} from 'svelte/store';
  import {tooltip} from '@/actions/tippy-action';
  import {thumbnail} from '@/store';

  export let element: HTMLElement;
  let elementText: string;
  export let elText: string;
  let open = false;
  let quoteFocus = false;
  let unsubThumbnail: any;

  function changedValue() {
    // element.removeAttribute('data-amelement');
    const dynamicElement = element.querySelector('.dynamic .ql-editor');
    if (dynamicElement) dynamicElement.innerHTML = elText;
    if (element.getAttribute('data-amelement') === 'quote') thumbnail.set({...$thumbnail, quote: elText});
    else if (element.getAttribute('data-amelement') === 'title') thumbnail.set({...$thumbnail, title: elText});
    else if (element.getAttribute('data-amelement') === 'pastorname')
      thumbnail.set({...$thumbnail, pastorName: elText});
  }

  function removeElement() {
    editorInstance.history.addHistory('Delete component');
    element.remove();
    getInstance().templateLoader.textLoader.identifyTextElements();
    editorStore.setActiveComponent(null);
  }

  function getElement() {
    return element.querySelector('.dynamic') as HTMLElement;
  }

  function toggle() {
    open = !open;
  }

  function toggleQuoteText() {
    editorStore.setActiveComponent(null);
    if (element.getAttribute('data-amelement') === 'quote' || element.getAttribute('data-amelement') === 'title') {
      quoteFocus = true;
      setTimeout(() => {
        document.getElementById('quoteText')?.focus();
      }, 10);
    }
  }

  function onMouseOver() {
    editorInstance.ui.highlight(element);
  }

  function onMouseLeave() {
    editorInstance.ui.removeHighlight();
  }

  function onMouseClick() {
    editorStore.setActiveComponent(element);
  }

  let isShowing = writable(true);

  function hide() {
    let htmlElement = document.querySelector<HTMLDivElement>('[data-amelement="quote"]');
    isShowing.update(value => {
      if (!htmlElement) {
        return true;
      }
      if (!value) {
        htmlElement.style.display = 'block';
      } else {
        htmlElement.style.display = 'none';
      }
      return !value;
    });
  }

  $: cssClass = $isShowing ? 'fa-eye' : 'fa-eye-slash';

  $: angleIcon = open ? 'fa-angle-up' : 'fa-angle-down';
  $: inputClass = quoteFocus ? 'hidden' : '';
  $: textAreaClass = quoteFocus ? '' : 'hidden';

  const unsubscribe = editorStore.subscribe(store => (open = store.activeComponent === element));

  onDestroy(() => {
    unsubscribe();
    if (unsubThumbnail) unsubThumbnail();
  });
</script>

<div
  class="{open ? 'bg-white' : ''} block rounded-xl border border-zinc-300"
  on:mouseover={onMouseOver}
  on:focus={onMouseOver}
  on:mouseleave={onMouseLeave}
>
  <div
    class="flex w-full items-center bg-white px-4 pt-4 {open
      ? 'mb-4 rounded-tl-xl rounded-tr-xl'
      : 'rounded-xl px-4 py-3'} "
  >
    <button class="nolineheight mr-3 block cursor-pointer" on:click={toggle} on:keypress={toggle}>
      <i class="fa {angleIcon}" />
    </button>
    <div class="relative mr-2 flex-grow rounded-xl border bg-white p-1">
      <input
        class="block w-full bg-white px-2 outline-transparent {inputClass}"
        bind:value={elText}
        on:input={changedValue}
        on:focus={() => toggleQuoteText()}
      />
      <textarea
        id="quoteText"
        class="block w-full bg-white px-2 outline-transparent {textAreaClass}"
        bind:value={elText}
        on:input={changedValue}
        on:blur={() => {
          quoteFocus = false;
        }}
        rows={3}
      ></textarea>
      <!-- <i class="fa fa-pencil absolute {open ? 'hidden' : 'right-4 top-3.5'}" on:click={toggle} on:keypress={toggle}/> -->
    </div>
    {#if element.getAttribute('data-amelement') === 'quote'}
      <button
        on:keypress={onMouseClick}
        on:click={onMouseClick}
        class="flex h-4 w-4 cursor-pointer items-center justify-center rounded text-sm font-bold text-gray-500 hover:text-secondary-600"
      >
        <i class="fa-solid fa-wand-magic-sparkles text-primary"></i>
      </button>
      <div
        class="ml-auto block cursor-pointer hover:bg-zinc-300"
        use:tooltip={'Show/Hide'}
        on:click|stopPropagation|preventDefault={hide}
        on:keypress={hide}
      >
        <i class="fa {cssClass}" />
      </div>
    {:else}
      <button
        on:keypress={removeElement}
        on:click={removeElement}
        class="flex h-4 w-4 cursor-pointer items-center justify-center rounded text-sm font-bold text-gray-500 hover:text-secondary-600"
      >
        <i class="fa-solid fa-x"></i>
      </button>
    {/if}
  </div>

  {#if open}
    <div class="rounded-bl-xl rounded-br-xl bg-zinc-100 p-4">
      {#if getElement()}
        <FontEditor target={getElement()} advanced={true} />
      {/if}
    </div>
  {/if}
</div>

<style lang="postcss">
  .fa.fa-pencil {
    font-size: 0.8rem;
  }
  .fa.fa-times {
    line-height: 0;
    font-size: 0.7rem;
  }
  .nolineheight {
    line-height: 0;
  }
</style>
